import { Sender } from "@ant-design/x";
import { useState } from "react";
import { useToken } from "../../hooks/useToken";
import { TMessage } from "../../models/ai.model";
import { TResponse } from "../../services/apiWorker";

export function AITextEditor({
  onAddMessage,
}: {
  onAddMessage: (message: string) => Promise<TResponse<TMessage>>;
}) {
  const { token } = useToken();

  const [value, setValue] = useState<string>("");
  const [isLoading, setLoading] = useState<boolean>(false);

  return (
    <>
      <Sender
        loading={isLoading}
        value={value}
        placeholder="Ask me anything..."
        style={{
          background: token.colorBgContainer,
          flexDirection: "column",
          alignItems: "flex-end",
          justifyContent: "flex-end",
          width: "100%",
          borderRadius: "8px",
          border: "1px solid " + token.colorBorder,

          outline: "none",
          color: token.colorText,
          boxShadow: "none",
        }}
        allowSpeech
        onChange={(v) => {
          setValue(v);
        }}
        onSubmit={async (value) => {
          setValue("");
          setLoading(true);
          await onAddMessage(value);
          setLoading(false);
        }}
        onCancel={() => {
          setLoading(false);
        }}
      />
      {/* <Divider style={{ margin: 0, padding: 0 }} /> */}
      {/* <Flex
          align="center"
          justify="space-between"
          style={{
            padding: "8px",
          }}
        >
          <Button type="text" icon={<RefreshHistoryIcon />} />
          <Flex>
            <Button
              type="text"
              icon={
                <CameraOutlined
                  style={{ color: token.colorText, fontSize: "24px" }}
                />
              }
            />
            <Button
              type="text"
              icon={<MicroPhoneIcon fill={token.colorText} />}
            />
            <Button type="text" icon={<SendIcon />} />
          </Flex>
        </Flex> */}
    </>
  );
}
